const getDateSortValue = (dateValue) => {
  const parsedDate = new Date(String(dateValue || '').trim());
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.getTime();
};

export const sortRowsByDateAscending = (rows = []) => (
  [...rows].sort((leftRow, rightRow) => {
    const leftTime = getDateSortValue(leftRow?.date);
    const rightTime = getDateSortValue(rightRow?.date);

    if (leftTime == null && rightTime == null) {
      return 0;
    }
    if (leftTime == null) {
      return 1;
    }
    if (rightTime == null) {
      return -1;
    }

    return leftTime - rightTime;
  })
);

export const normalizeReturnRows = (rows = []) => (
  sortRowsByDateAscending(
    (Array.isArray(rows) ? rows : [])
      .filter((row) => row?.date != null && row?.return != null)
      .map((row, index) => ({
        id: row.id ?? index + 1,
        date: String(row.date).trim(),
        return: String(row.return).trim(),
      })),
  )
);
